import { Col, Row } from 'antd';
import Text from 'components/Text';
import cashierActions from 'features/cashier/services/actions';
import { FEATURE_PRODUCT_MODE } from 'features/cashier/services/constants';
import cashierSelectors from 'features/cashier/services/selectors';
import { useEffect } from 'react';
import shopSelectors from 'services/shop/selectors';
import { useAppDispatch } from 'store/hooks';
import GiftCard from './GiftCard';
import Package from './Package';
import Product from './Product';
import Services from './Services';
import VIP from './VIP';
import styled from 'styled-components';
import ButtonQuickPay from '../ButtonQuickPay';
type Props = {
  v2?: boolean;
};
const ExtendFeatures = ({ v2 }: Props) => {
  const dispatch = useAppDispatch();
  const displayPackageService = shopSelectors.data.displayPackageService();
  const featureProductMode = cashierSelectors.getFeatureProductMode();

  useEffect(() => {
    // setting Packages bị tắt trong lúc đang ở panel Packages thì quay về panel Service
    if (!displayPackageService && featureProductMode === FEATURE_PRODUCT_MODE.PACKAGE) {
      dispatch(cashierActions.setFeatureProductMode(FEATURE_PRODUCT_MODE.SERVICE));
    }
  }, [displayPackageService, featureProductMode]);

  if (v2) {
    return (
      <Container>
        <Services v2 />
        <Package v2 />
        <GiftCard v2 />
        <VIP v2 />
        <ButtonQuickPay v2 />
        <Product v2 />
      </Container>
    );
  }

  // 5 tab không chia đều được bằng span của lưới 24 cột; 4 tab giữ span={6} như cũ.
  // flex số của antd thành "1 1 auto" (rộng theo nội dung) nên dùng basis 0 để 5 tab rộng bằng nhau
  const colProps = displayPackageService ? { flex: '1 1 0', style: { minWidth: 0 } } : { span: 6 };
  return (
    <>
      <Row gutter={[12, 12]}>
        <Col {...colProps}>
          <Services />
        </Col>
        {displayPackageService && (
          <Col {...colProps}>
            <Package />
          </Col>
        )}
        <Col {...colProps}>
          <GiftCard />
        </Col>
        <Col {...colProps}>
          <VIP />
        </Col>
        <Col {...colProps}>
          <Product />
        </Col>
      </Row>
      <Text mb={1.125} />
    </>
  );
};

export default ExtendFeatures;
const Container = styled.div`
  max-height: 126px;
  height: 126px;
  background: #fff;
  box-shadow: 0px 4px 8px -4px rgba(0, 0, 0, 0.25);
  display: flex;
  align-items: center;
  padding: 0rem 1.125rem;
  align-self: stretch;
  gap: 8px;
`;
